function initRipple(selectors = '', canClickOutside = false) {
  //   "use strict";

  var colour = '#8c9ab2'
  var opacity = 0.3
  var ripple_without_diameter = 50

  function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling)
  }

  var overlays = {
    items: [],
    get: function (autoInsert = true) {
      var $element
      for (var i = 0; i < overlays.items.length; i++) {
        $element = overlays.items[i]
        if ($element.transition_phase === false) {
          $element.transition_phase = 0
          return $element
        }
      }
      $element = document.createElement('div')
      $element.style.position = 'absolute'
      $element.style.opacity = opacity
      //$element.style.outline = "10px solid red";
      $element.style.pointerEvents = 'none'
      $element.style.background =
        '-webkit-radial-gradient(' +
        colour +
        ' 64%, rgba(0,0,0,0) 65%) no-repeat'
      $element.style.background =
        'radial-gradient(' + colour + ' 64%, rgba(0,0,0,0) 65%) no-repeat'
      $element.style.transform = 'translateZ(0)'
      $element.transition_phase = 0
      $element.rid = overlays.items.length
      $element.next_transition = overlays.next_transition_generator($element)
      if (autoInsert) document.body.appendChild($element)
      overlays.items.push($element)
      return $element
    },
    next_transition_generator: function ($element) {
      return function () {
        $element.transition_phase++
        switch ($element.transition_phase) {
          case 1:
            $element.style[transition] = 'all 0.2s ease-in-out'
            $element.style.backgroundSize = $element.ripple_backgroundSize
            $element.style.backgroundPosition =
              $element.ripple_backgroundPosition
            setTimeout($element.next_transition, 0.2 * 1000) //now I know transitionend is better but it fires multiple times when multiple properties are animated, so this is simpler code and (imo) worth tiny delays
            break
          case 2:
            $element.style[transition] = 'opacity 0.15s ease-in-out'
            $element.style.opacity = 0
            setTimeout($element.next_transition, 0.15 * 1000)
            break
          case 3:
            overlays.recycle($element)
            break
        }
      }
    },
    recycle: function ($element) {
      $element.style.display = 'none'
      $element.style[transition] = 'none'
      if ($element.timer) clearTimeout($element.timer)
      $element.transition_phase = false
      $element.remove()
    },
  }

  var transition = (function () {
    var i,
      el = document.createElement('div'),
      transitions = {
        WebkitTransition: 'webkitTransition',
        transition: 'transition',
        OTransition: 'otransition',
        MozTransition: 'transition',
      }
    for (i in transitions) {
      if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
        return transitions[i]
      }
    }
  })()

  var click = function (event) {
    var $element = overlays.get(false),
      touch,
      x,
      y

    touch = event.touches ? event.touches[0] : event

    $element.style[transition] = 'none'
    $element.style.backgroundSize = '3px 3px'
    $element.style.opacity = opacity
    $element.style.position = 'absolute'
    const targetElement = touch.target.closest(selectors)
    if (targetElement?.matches(selectors)) {
      // insertAfter(targetElement, $element);
      targetElement.appendChild($element)
      x = touch.offsetX
      y = touch.offsetY

      var dimensions = targetElement.getBoundingClientRect()
      if (!x || !y) {
        x = (touch.clientX || touch.x) - dimensions.left
        y = (touch.clientY || touch.y) - dimensions.top
      }
      $element.style.backgroundPosition = x + 'px ' + y + 'px'
      $element.style.width = dimensions.width + 'px'
      $element.style.height = dimensions.height + 'px'
      $element.style.top = '0px'
      $element.style.left = '0px'
      // $element.style.left = dimensions.left + "px";
      // $element.style.top =
      //   dimensions.top +
      //   document.body.scrollTop +
      //   document.documentElement.scrollTop +
      //   "px";
      var computed_style = window.getComputedStyle(event.target)
      for (var key in computed_style) {
        if (key.toString().indexOf('adius') > -1) {
          if (computed_style[key]) {
            $element.style[key] = computed_style[key]
          }
        } else if (
          parseInt(key, 10).toString() === key &&
          computed_style[key].indexOf('adius') > -1
        ) {
          $element.style[computed_style[key]] =
            computed_style[computed_style[key]]
        }
      }
      $element.style.backgroundPosition = x + 'px ' + y + 'px'
      $element.ripple_backgroundPosition =
        x - dimensions.width + 'px ' + (y - dimensions.width) + 'px'
      $element.ripple_backgroundSize =
        dimensions.width * 2 + 'px ' + dimensions.width * 2 + 'px'
      $element.style.zIndex = 1

      const cssObj = window.getComputedStyle(targetElement, null)
      let borderRadius = cssObj.getPropertyValue('border-radius')
      $element.style.borderRadius = borderRadius
    } else if (canClickOutside) {
      //click was outside of ripple element
      x = touch.clientX || touch.x || touch.pageX
      y = touch.clientY || touch.y || touch.pageY

      $element.style.borderRadius = '0px'
      $element.style.left = x - ripple_without_diameter / 2 + 'px'
      $element.style.top =
        document.body.scrollTop +
        document.documentElement.scrollTop +
        y -
        ripple_without_diameter / 2 +
        'px'
      $element.ripple_backgroundSize =
        ripple_without_diameter + 'px ' + ripple_without_diameter + 'px'
      $element.style.width = ripple_without_diameter + 'px'
      $element.style.height = ripple_without_diameter + 'px'
      $element.style.backgroundPosition = 'center center'
      $element.ripple_backgroundPosition = 'center center'
      $element.ripple_backgroundSize =
        ripple_without_diameter + 'px ' + ripple_without_diameter + 'px'
      $element.style.zIndex = 100
    } else {
      return
    }
    $element.ripple_x = x
    $element.ripple_y = y
    $element.style.display = 'block'
    setTimeout($element.next_transition, 20)
  }

  if ('ontouchstart' in window || 'onmsgesturechange' in window) {
    document.addEventListener('click', click, false)
    // document.addEventListener("touchstart", click, false);
  } else {
    document.addEventListener('click', click, false)
  }
}
try {
  initRipple('.ripple,.buttonComponent')
} catch (error) {
  console.log(error)
}
